module.exports = function () {
    var featuredTopicListClass = 'featured-topic-list';
    var featuredTopicListSelector = '.' + featuredTopicListClass;

    
    if ($(featuredTopicListSelector).length === 0 || $('.body--experience-editor-editing').length ) {
        return;
    }
    
    // owl carousel initialization
    $('.featured-topic-list').not('.featured-topic-list--experience-editor-editing').each(function () {
        var $list = $(this);
        var currentIndex, breakpoints;

        if ($list.hasClass('module--spacious')) {
            breakpoints = {
                0: {
                    items: 1,
                    stagePadding: 0
                },
                768: {
                    items: 2,
                    stagePadding: 0
                },
                992: {
                    items: 2,
                    stagePadding: 0
                },
                1200: {
                    items: 3,
                    stagePadding: 0
                }
            };            
        }
        else {
            breakpoints = {
                0: {
                    items: 1,
                    stagePadding: 20
                },
                768: {
                    items: 3,
                    stagePadding: 50
                }
            };
        }

        var owlCarouselSettings = {
            nav: false,
            dots: true,
            margin: 0,
            responsive: breakpoints,
            callbacks: true,
            onChanged: function (event) {
                var $el = $(event.target);

                var item = event.item.index;
                var items = event.item.count;

                var $prev = $el.parents('.featured-topic-list').find('.featured-topic-list__cta--prev');
                var $next = $el.parents('.featured-topic-list').find('.featured-topic-list__cta--next');

                $prev.removeClass('featured-topic-list__cta--hidden');
                $next.removeClass('featured-topic-list__cta--hidden');

                if (event.page.size == event.item.count) {
                    $prev.addClass('featured-topic-list__cta--disabled');
                    $next.addClass('featured-topic-list__cta--disabled');
                    $prev.addClass('featured-topic-list__cta--hidden');
                    $next.addClass('featured-topic-list__cta--hidden');
                }
                else if (item === 0) {
                    $prev.addClass('featured-topic-list__cta--disabled');
                    $next.removeClass('featured-topic-list__cta--disabled');
                }
                else if ((item + event.page.size) === items) {
                    $prev.removeClass('featured-topic-list__cta--disabled');
                    $next.addClass('featured-topic-list__cta--disabled');
                }
                else {
                    $prev.removeClass('featured-topic-list__cta--disabled');
                    $next.removeClass('featured-topic-list__cta--disabled');
                }
            }
        };
        
        var $cards = $list.find('.universal-grid.universal-grid--featured');
        $cards.on('initialized.owl.carousel', centerFeaturedCards);
        $cards.addClass('owl-carousel');
        $cards.owlCarousel(owlCarouselSettings);
        var $next = $list.find('.featured-topic-list__cta--next');

        $next.click(function () {
            $cards.trigger('next.owl.carousel');
        });

        var $prev = $list.find('.featured-topic-list__cta--prev');
        $prev.click(function () {
            $cards.trigger('prev.owl.carousel');
        });

        // set appropriate settings per breakpoint per carousel
        var centerFeaturedCards = function () {
            var currentWidth = window.innerWidth;
            var currentBreakpointInfo = null;

            var breakpointKeys = Object.keys(breakpoints);
            for (var i in breakpointKeys) {
                if (breakpointKeys.hasOwnProperty(i) && breakpointKeys[i] <= currentWidth) {
                    currentBreakpointInfo = breakpoints[breakpointKeys[i]];
                }
            }

            var numItems = currentBreakpointInfo.items;

            if (currentIndex !== numItems) {
                currentIndex = numItems;

                var activeItemIndex = $list.find('.owl-item.active').first().index();
                var clonedItemIndexOffset = $list.find('.owl-item.cloned').filter(function (index) { return $(this).index() <= activeItemIndex; }).length;

                if (clonedItemIndexOffset > 0) {
                    activeItemIndex = activeItemIndex - clonedItemIndexOffset;
                }

                var $cards = $list.find('.universal-grid.universal-grid--featured');
                var cardsLength = $cards.find('.universal-grid-item').length;

                var $nav = $list.find('.featured-topic-list__navigation');

                // is currently a carousel                
                if ($cards.hasClass('owl-loaded') && cardsLength <= numItems) {
                    $cards.owlCarousel('destroy');
                    $cards.removeClass('owl-carousel');

                    $nav.addClass('featured-topic-list__navigation--hidden');
                }
                else if (cardsLength > numItems) {
                    $cards.on('initialized.owl.carousel', centerFeaturedCards);
                    $cards.addClass('owl-carousel');
                    $cards.owlCarousel(owlCarouselSettings);
                    $nav.removeClass('featured-topic-list__navigation--hidden');
                }
            }
        };

        $(window).resize(function () {
            setTimeout(centerFeaturedCards(), 200);
        });
    });    
};